<div class="ots">
  <div class="ots__header">
    <div class="ots__title-row">
      <div class="ots__title-block">
        <h2 class="ots__title">Offer time slots in email</h2>
        @if (event?.name) {
          <div class="ots__event-line">
            <span class="ots__event-dot" [style.background]="event?.color?.primary || '#8247F5'"></span>
            <span class="ots__event-name">{{ event.name }}</span>
          </div>
        }
      </div>
      <button type="button" class="ots__close" (click)="close()" aria-label="Close">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"></line>
          <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"></line>
        </svg>
      </button>
    </div>
  </div>

  <div class="ots__body">
    <div class="ots__intro">
      Copy time slot suggestions and paste them into an email message to share your availability.
      Your full booking page link will also be included.
    </div>

    <div class="ots__field">
      <label class="ots__field-label">Offer availability</label>
      <div class="ots__select-wrap">
        <svg class="ots__select-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <select class="ots__select" [value]="selectedRange" (change)="onRangeChange($any($event.target).value)">
          @for (opt of rangeOptions; track opt.key) {
            <option [value]="opt.key">{{ opt.label }}</option>
          }
        </select>
        <svg class="ots__select-caret" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </div>
    </div>

    <div class="ots__preview">
      <div class="ots__preview-header">Preview</div>

      <div class="ots__preview-body">
        @if (loading) {
          <div class="ots__loading">
            <mat-spinner diameter="32"></mat-spinner>
          </div>
        } @else if (errorMessage) {
          <div class="ots__error">{{ errorMessage }}</div>
        } @else if (!groupedSlots.length) {
          <div class="ots__empty">No available times in this range.</div>
        } @else {
          <div class="ots__tz-block">
            <div class="ots__tz-label">Displayed time zone</div>
            <div class="ots__tz-value">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="2" y1="12" x2="22" y2="12"></line>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
              </svg>
              <span>{{ eventTimezoneLabel }}</span>
            </div>
          </div>

          @for (day of groupedSlots; track day.dateStr) {
            <div class="ots__day" [class.ots__day--editing]="editingDateStr === day.dateStr">
              <div class="ots__day-header">
                <span class="ots__day-label">{{ day.dateLabel }}</span>
                <div class="ots__day-actions">
                  <button type="button"
                    class="ots__day-action"
                    matTooltip="Edit times"
                    cdkOverlayOrigin
                    #editTrigger="cdkOverlayOrigin"
                    (click)="onOpenEdit(day, $event)">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <path d="M12 20h9"></path>
                      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                    </svg>
                  </button>
                  <button type="button"
                    class="ots__day-action"
                    matTooltip="Remove date"
                    [disabled]="groupedSlots.length <= 1"
                    (click)="onRemoveDate(day, $event)">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                      <line x1="10" y1="11" x2="10" y2="17"></line>
                      <line x1="14" y1="11" x2="14" y2="17"></line>
                      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    </svg>
                  </button>

                  <ng-template
                    cdk-connected-overlay
                    [cdkConnectedOverlayOrigin]="editTrigger"
                    [cdkConnectedOverlayOpen]="editingDateStr === day.dateStr"
                    [cdkConnectedOverlayHasBackdrop]="true"
                    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
                    [cdkConnectedOverlayPositions]="overlayPositions"
                    (backdropClick)="closeEdit()"
                    (detach)="closeEdit()">
                    <div class="ots__edit-popover">
                      <div class="ots__edit-header">
                        <div class="ots__edit-title">Available times</div>
                        <div class="ots__edit-links">
                          <button type="button" class="ots__edit-link" (click)="selectAllInEdit(day)">select all</button>
                          <span class="ots__edit-link-sep">/</span>
                          <button type="button" class="ots__edit-link" (click)="clearAllInEdit()">clear</button>
                        </div>
                      </div>
                      <div class="ots__edit-list">
                        @for (slot of day.allSlots; track slot.time) {
                          <label class="ots__edit-item">
                            <input type="checkbox"
                              [checked]="isEditingSelected(slot.time)"
                              (change)="toggleEditingSlot(slot.time)">
                            <span>{{ slot.time }}</span>
                          </label>
                        }
                      </div>
                      <div class="ots__edit-footer">
                        <button type="button" class="ots__btn ots__btn--secondary" (click)="closeEdit()">Cancel</button>
                        <button type="button"
                          class="ots__btn ots__btn--primary"
                          [disabled]="!canConfirmEdit()"
                          (click)="confirmEdit(day)">
                          Done
                        </button>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>

              @if (day.visibleSlots.length) {
                <div class="ots__chips">
                  @for (slot of day.visibleSlots; track slot.url) {
                    <a class="ots__chip" [href]="slot.url" target="_blank" rel="noopener noreferrer" [title]="slot.startLabel + ' – ' + slot.endLabel">
                      {{ slot.startLabel }}
                    </a>
                  }
                </div>
              } @else {
                <div class="ots__day-empty">No times selected — use Edit to choose times.</div>
              }
            </div>
          }
        }
      </div>
    </div>
  </div>

  <div class="ots__footer">
    <button type="button" class="ots__btn ots__btn--secondary" (click)="close()">Cancel</button>
    <button type="button"
      class="ots__btn ots__btn--primary"
      [disabled]="loading || !groupedSlots.length || !!errorMessage"
      (click)="onCopy()">
      @if (copied) {
        <svg class="ots__btn-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <span>Copied</span>
      } @else {
        <svg class="ots__btn-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
        </svg>
        <span>Copy to clipboard</span>
      }
    </button>
  </div>
</div>
